import { createContext } from "react"

const LocationContext = createContext({
  location: {},
})

export default LocationContext
